import axiosIns  from "../axios";


export const userService = {
    login,
    logout,
    me,
};

function login(email, password) {
    
    const requestOptions = { email, password };
    return axiosIns.post(`login`, requestOptions)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.data.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('token', user.data.token);
            }
            return user;
        });
}

function logout() {

    // remove user from local storage to log user out
    localStorage.removeItem('token');
    localStorage.removeItem('userdata');
}

function me(token) {
    return axiosIns.get(`me`,{
            headers: {
                'Authorization': `Bearer ${token}` 
            }
        })
        .then(user => user );
}

// eslint-disable-next-line no-unused-vars
function handleResponse(response) {
   
    return response.text().then(text => {
 
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
